export default __webpack_public_path__ + "static/media/plugin-beta-step3.396c1e17.gif";